<template>
    <div class="home">
        <span>Hello World!</span>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'home',
    metaInfo: {// vue-meta设置页面的title和meta信息
        title: 'zhong',
        meta: []
    },
    data () {
        return {}
    },
    mounted () {
        console.log(this)
    }
}
</script>
<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
